var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.691,
    height: 14,
    viewBox: "0 0 13.691 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M7.111,0A6.576,6.576,0,0,0,2.264,11.024L.149,13.135a.507.507,0,0,0,.716.718l2.141-2.135A6.578,6.578,0,1,0,7.111,0Zm0,1.013A5.566,5.566,0,1,1,1.545,6.579,5.572,5.572,0,0,1,7.111,1.013Z",
    transform: "translate(0)",
    fill: "#050317",
    fillRule: "evenodd",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5346cefc9de33ae32edd1da9ad39ab1d.svg";
export { ForwardRef as ReactComponent };